import { TablePagination } from '@trendmicro/react-paginations';
import React from 'react';

const Pagination = ({ type = 'full', page, pageLength, totalRecords, onPageChange, pageLengthMenu = [10, 25, 50, 100] }) => {
  return (
    <TablePagination
      type={type}
      page={page}
      pageLength={pageLength}
      totalRecords={totalRecords}
      pageLengthMenu={pageLengthMenu}
      onPageChange={({ page, pageLength }) => {
        onPageChange?.(page, pageLength);
      }}
      prevPageRenderer={() => <i className="fa fa-angle-left" />}
      nextPageRenderer={() => <i className="fa fa-angle-right" />}
    />
  );
};

export default Pagination;
